"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalTokens = void 0;
const BorderRadius_1 = require("./global/BorderRadius");
const BorderWidth_1 = require("./global/BorderWidth");
const BoxShadow_1 = require("./global/BoxShadow");
const Colors_1 = require("./global/Colors");
const ControlSize_1 = require("./global/ControlSize");
const Fields_1 = require("./global/Fields");
const FocusRing_1 = require("./global/FocusRing");
const ModalSize_1 = require("./global/ModalSize");
const OldTokens_1 = require("./global/OldTokens");
const Size_1 = require("./global/Size");
const Spacing_1 = require("./global/Spacing");
const Typography_1 = require("./global/Typography");
exports.globalTokens = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ControlSize_1.controlSizeTokens), Size_1.sizeTokens), BorderRadius_1.borderRadiusTokens), Spacing_1.spacingTokens), Colors_1.colorTokens), Typography_1.typographyTokens), BorderWidth_1.borderWidthTokens), BoxShadow_1.boxShadowTokens), Fields_1.fieldsTokens), ModalSize_1.modalSizeTokens), FocusRing_1.focusRingTokens), { oldTokens: OldTokens_1.oldTokens });
//# sourceMappingURL=Global.js.map